module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Length")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.propertyDescription.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Width")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.propertyDescription.width))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Area")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.propertyDescription.area))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Boundary estimates based on")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "row well"
  }, _vm._l((_vm.boundaryTypeSelectedList), function(boundaryType) {
    return _c('div', {
      staticClass: "col-md-3 checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (boundaryType.boundaryTypeId),
        expression: "boundaryType.boundaryTypeId"
      }],
      attrs: {
        "readonly": "",
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(boundaryType.boundaryTypeId) ? _vm._i(boundaryType.boundaryTypeId, null) > -1 : (boundaryType.boundaryTypeId)
      },
      on: {
        "change": function($event) {
          var $$a = boundaryType.boundaryTypeId,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (boundaryType.boundaryTypeId = $$a.concat([$$v]))
            } else {
              $$i > -1 && (boundaryType.boundaryTypeId = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(boundaryType, "boundaryTypeId", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v(_vm._s(boundaryType.description))])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40537c7f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteProduction/PropertyDescription.vue
// module id = 927
// module chunks = 1